import React, { useEffect } from "react"
import { Box, Skeleton, styled } from "@mui/material"

import { colors } from "theme"
import { useAppDispatch, useAppSelector } from "redux/hooks"
import { fetchPlans } from "redux/features/plan/planThunk"
import {
  selectFetchCollectionStatus,
  selectPlans,
} from "redux/features/plan/planSlice"
import LoadableCollection from "components/ui/LoadableCollection"
import { PlanListType } from "types"

export function withPlans<GenericType>(
  WrappedComponent: React.ComponentType<GenericType>,
) {
  const WithPlans = (props: GenericType) => {
    const dispatch = useAppDispatch()

    const plans = useAppSelector((state) => selectPlans(state)) as PlanListType
    const fetchStatus = useAppSelector((state) =>
      selectFetchCollectionStatus(state),
    )

    const handleFetchPlans = () => {
      if (!fetchStatus.isFetching) {
        dispatch(fetchPlans())
      }
    }

    useEffect(() => handleFetchPlans(), [])

    const renderSkeleton = () => {
      return (
        <Container>
          <Card sx={{ height: 360 }} animation="pulse" variant="rectangular" />
          <Card sx={{ height: 360 }} animation="pulse" variant="rectangular" />
          <Card sx={{ height: 360 }} animation="pulse" variant="rectangular" />
        </Container>
      )
    }

    return (
      <LoadableCollection
        fetchStatus={fetchStatus}
        renderLoading={renderSkeleton}
      >
        {() => (
          <WrappedComponent
            {...props}
            plans={plans}
            fetchStatus={fetchStatus}
            fetchDebts={handleFetchPlans}
          />
        )}
      </LoadableCollection>
    )
  }

  return WithPlans
}

const Container = styled(Box)`
  display: flex;
  flex-wrap: nowrap;
  justify-content: center;
  align-items: center;
  margin: 42px 0 0 0;
`

const Card = styled(Skeleton)`
  background-color: ${colors.cultured};
  box-shadow: 12px 14px 23px -2px rgb(0 0 0 / 3%);
  border-radius: 26px;
  margin: 0 16px;
  padding: 58px;
  width: 30%;
`
